class JewelerList extends HTMLElement {
  static observedAttributes = ['query', 'owned-store', 'countries'];

  connectedCallback() {
    this.jewelers = this.getJewelers();
    this.letterGroups = this.getLetterGroups();
  }

  /**
   * Handle the search input event
   */
  filterJewelers() {
    const query = this.getAttribute('query')?.toLowerCase();
    const ownedStore = this.getAttribute('owned-store') === 'true' ? true : false;
    const countries = this.getAttribute('countries')?.toLowerCase();
    const countryArr = countries ? countries.split(',') : [];

    this.jewelers.forEach((jeweler) => {
      // Check if the jeweler matches the query
      const matchesQuery = query
        ? jeweler.name.toLowerCase().includes(query) ||
          jeweler.city.toLowerCase().includes(query) ||
          jeweler.zip.includes(query)
        : true;

      // Check if the jeweler is an owned store
      const matchesOwnedStore = ownedStore ? jeweler.ownedStore === 'true' : true;

      // Check if the jeweler matches the country
      const matchesCountry =
        countryArr.length === 0 || countryArr.includes(jeweler.country.toLowerCase());

      // Toggle the visibility of the jeweler
      const element = this.querySelector(`[data-jeweler-id="${jeweler.id}"]`).parentElement;
      element.classList.toggle('hidden', !(matchesQuery && matchesOwnedStore && matchesCountry));
    });

    // Toggle the visibility of the letter groups
    this.toggleLetterGroups();
  }

  /**
   * Toggle the visibility of the letter
   */
  toggleLetterGroups() {
    this.letterGroups.forEach((group) => {
      const visibleJewelers = group.element.querySelectorAll(
        '.jeweler-list__letter-list-item:not(.hidden)'
      ).length;

      group.element.classList.toggle('hidden', visibleJewelers === 0);
    });
  }

  /**
   * Get all jewelers from the jeweler-list element
   * @returns {Array} Array of jeweler objects
   */
  getJewelers() {
    // Get all elements with the attribute data-jeweler-id
    return Array.from(this.querySelectorAll('[data-jeweler-id]')).map(({ dataset }) => {
      // Only get the dataset values that starts with data-jeweler
      return Object.keys(dataset)
        .filter((key) => key.startsWith('jeweler'))
        .reduce((acc, key) => {
          // Remove the jeweler prefix from the key and lowercase the first letter
          const newKey = key.replace('jeweler', '').charAt(0).toLowerCase() + key.slice(8);

          return {
            ...acc,
            [newKey]: dataset[key],
          };
        }, {});
    });
  }

  getLetterGroups() {
    return Array.from(this.querySelectorAll('.jeweler-list__letter')).map((group) => {
      return {
        letter: group.dataset.letter,
        element: group,
      };
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.filterJewelers();
    }
  }
}

if (!customElements.get('jeweler-list')) {
  customElements.define('jeweler-list', JewelerList);
}
